import { CockpitNotification } from "../notification";
import { UserNotification } from "./api";

export default function mapNotification(userNotification: UserNotification): CockpitNotification {
    return {
        message: userNotification.title,
        id: userNotification.id,
        type: userNotification.sourceSystem,
        time: new Date(userNotification.updatedAt),
    };
}
